// extracted by mini-css-extract-plugin
export default {"pageWrap":"bb-z","fullWidth":"cb-z","heading":"db-z","fullBleed":"eb-z","hidden":"fb-z"};